import * as journalActions from '../actions/jobsearch'
import * as h2Api from '../h2Api'
import { POPUP_JOURNAL_COMPLETION } from '../actions/journals'
import { handleReducingJournalForItem } from '../actions'

const initialState = {
  profile: null
}
const data = (state = initialState, action) => {
  switch (action.type) {
    case journalActions.CLEAR_SELECTED:
      return initialState

    case journalActions.JOB_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result
        const contentParts = p.body ? p.body.split('<script id="detrack"') : ''

        return {
          ...state,
          profile: {
            ...p,
            body: contentParts.length > 0 ? contentParts[0] : p.body,
            script:
              contentParts.length > 0 ? `<script id="detrack"${contentParts[1]}` : null
          }
        }
      }

      return state

    case journalActions.RATE_JOB:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const { rating, ...itms } = state.profile.personalization
        const s = {
          ...state,
          profile: {
            ...state.profile,
            personalization: {
              ...itms,
              ...action.restCall.result
            }
          }
        }

        return s
      }

      return state

    case POPUP_JOURNAL_COMPLETION:
      return handleReducingJournalForItem(action, state, 'profile')

    default:
      return state
  }
}

export default data
